<template>
  <b-container v-if="abc_curve_context_loaded" fluid class="px-2">
    <b-container fluid class="px-0 pb-4">
      <highcharts :options="chartOptions"></highcharts>
    </b-container>
    <info-icon class="m-0 mb-2" info="Duplo clique no nome para ir para o produto"></info-icon>
    <b-row id="products-table-abc">
      <b-col v-for="(obj, i) in ClassProductObject" :key="'product-abc-' + i" lg="4" md="12" class="mb-4">
        <div class="white-box px-2">
          <b-row :class="'product-table-header table-header mb-2 ' + obj.bg">
            <b-col class="text-base" style="text-align: center;">
              <span style="color: white" class="d-inline-block align-middle">{{ obj.title }}</span>
            </b-col>
          </b-row>
          <b-row class="text-base mb-2">
            <b-col>
              <b-row class="text-12 m-0 py-1">
                <span :style="'color: ' + obj.color" v-html="obj.bullet"/>
                &nbsp;{{ obj.resume.quantity_percent }} do volume total de vendas
                  <span class="text-12">&nbsp;({{ obj.resume.quantity }})</span>
              </b-row>
              <b-row class="text-12 m-0 py-1">
                <span :style="'color: ' + obj.color" v-html="obj.bullet"/>
                &nbsp;{{ obj.resume.total_sold_percent }} do faturamento total
                  <span class="text-12">&nbsp;({{ obj.resume.total_sold }})</span>
              </b-row>
              <b-row class="text-12 m-0 py-1">
                <span :style="'color: ' + obj.color" v-html="obj.bullet"/>
                &nbsp;{{ obj.resume.total_cost_percent }} do custo total
                  <span class="text-12">&nbsp;({{ obj.resume.total_cost }})</span>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-table
              :id="'table-' + i"
              class="text-base text-12 "
              style="color: #666666;"
              :items="obj.info"
              :fields="fields"
              @row-dblclicked="onRowDoubleClicked"
              head-variant="light" striped hover
              fixed>
              <template v-slot:cell(show_details)="row">
                <img src="@/assets/abc_curve/eye.png" width="24" @click="row.toggleDetails"
                  class="text-base text-12 table-details-color mr-2"
                  :style="obj.img_color">
              </template>

              <template v-slot:row-details="row">
                <b-card>
                  <b-row>
                    <b-col cols="auto">
                      <img v-if="row.item.name !== 'Total'"
                        :src="row.item.main_image_url"
                        alt="product-img">
                    </b-col>
                    <b-col align-self="center">
                      <b-row v-if="row.item.name !== 'Total'" class="mb-2">
                        <b>SKU:</b>&nbsp;{{ row.item.main_product_sku }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Faturamento:</b>&nbsp;{{ row.item.total_sold }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Custo:</b>&nbsp;{{ row.item.total_cost }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Volume:</b>&nbsp;{{ row.item.quantity }}
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </template>
            </b-table>
          </b-row>
          <b-row class="mx-0 mb-1" align-h="center">
            <b-button :class="'w-100 text-base text-14 table-details-color ' + obj.bg"
              @click="showProducts(i)"
            >Ver todos os produtos desta curva</b-button>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="408px" class="mr-2 mb-2 ml-2"/>
</template>

<script>
import Highcharts from 'highcharts'
import LoaderBox from '@/components/LoaderBox.vue'
import InfoIcon from '@/components/InfoIcon.vue'

export default {
  components: {
    LoaderBox,
    InfoIcon
  },
  data: () => ({
    fields: [{
      key: 'name',
      label: 'nome'
    }, {
      key: 'total_sold',
      label: 'faturamento'
    }, {
      key: 'show_details',
      label: '',
    }]
  }),
  computed: {
    abc_curve_context_loaded() { return this.$store.getters.abc_curve_context_loaded },
    ClassProductObject() { return this.$store.getters.ClassProductObject },

    chartOptions() {
      const ABC_GRAPH_DATA_A = this.$store.getters.abc_graph_data_a;
      const ABC_GRAPH_DATA_B = this.$store.getters.abc_graph_data_b;
      const ABC_GRAPH_DATA_C = this.$store.getters.abc_graph_data_c;
      const ITEM_MARK_A = this.$store.getters.item_mark_a;
      const ITEM_MARK_B = this.$store.getters.item_mark_b;
      const ITEM_MARK_C = this.$store.getters.item_mark_c;

      return {
        chart: {
          type: 'area'
        },
        title: {
          text: 'Curva ABC de vendas'
        },
        colors: ['#7ABA1E', '#0BA7DA', '#FCBC2C'],
        xAxis: {
          labels: {
            formatter: function () {
              return Highcharts.numberFormat(this.value * 100 / this.axis.dataMax, 0) + '%'; // clean, unformatted number for year
            }
          }
        },
        yAxis: {
          title: {
            text: 'Faturamento (R$)'
          },
          labels: {
            formatter: function () {
              return this.value / 1000 + 'k';
            }
          }
        },
        series: [{
          name: 'Curva A',
          data: ABC_GRAPH_DATA_A.y,
          pointStart: ITEM_MARK_A,
          tooltip: {
            headerFormat: '',
            pointFormatter: function () {
              return '<span style="color: ' + this.color + ';">\u25CF</span><span> Faturamento: R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25CF</span> Custo: R$ ' + Highcharts.numberFormat(ABC_GRAPH_DATA_A.total_cost_number[this.index], 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25CF</span> Volume: ' + Highcharts.numberFormat(ABC_GRAPH_DATA_A.quantity_number[this.index], 0, ',', '.') + '</span>'
            },
          }
        }, {
          name: 'Curva B',
          data: ABC_GRAPH_DATA_B.y,
          pointStart: ITEM_MARK_B,
          tooltip: {
            headerFormat: '',
            pointFormatter: function () {
              return '<span style="color: ' + this.color + ';">\u25C6</span><span> Faturamento: R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25C6</span> Custo: R$ ' + Highcharts.numberFormat(ABC_GRAPH_DATA_B.total_cost_number[this.index], 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25C6</span> Volume: ' + Highcharts.numberFormat(ABC_GRAPH_DATA_B.quantity_number[this.index], 0, ',', '.') + '</span>'
            },
          }
        }, {
          name: 'Curva C',
          data: ABC_GRAPH_DATA_C.y,
          pointStart: ITEM_MARK_C,
          tooltip: {
            headerFormat: '',
            pointFormatter: function () {
              return '<span style="color: ' + this.color + ';">\u25A0</span><span> Faturamento: R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25A0</span> Custo: R$ ' + Highcharts.numberFormat(ABC_GRAPH_DATA_C.total_cost_number[this.index], 2, ',', '.') +
                '<br/><span style="color: ' + this.color + ';">\u25A0</span> Volume: ' + Highcharts.numberFormat(ABC_GRAPH_DATA_C.quantity_number[this.index], 0, ',', '.') + '</span>'
            },
          }
        }]
      }
    }
  },
  methods: {
    onRowDoubleClicked(item) {
      // No momento não consegui por um reverse aqui tbm
      window.open(this.$store.getters.baseUrl + '/shoppub-v2/produtos/produto/?q=' + item.name + '&tipo_produto_exibicao=1', '_blank');
    },
    showProducts(curveType) {
      // o=-11 serve para ordenar pelo faturamento com descontos
      window.open(this.$store.getters.baseUrl + '/shoppub-v2/relatorios_pedidos/reportorderbyproductmaingrouped/?curve_abc_products=' + curveType + '&date_choice=1&date_period=' + this.$store.getters.abcAdminPeriod + '&o=-11', '_blank');
    }
  }
}
</script>

<style lang='scss'>
  .product-table-header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-left: -8px !important;
    margin-right: -8px !important;
    margin-top: -3px !important
  }

  #products-table-abc {
    tr {
      text-align-last: start;
    }
    tr:last-child {
      font-weight: bold;
    }
    td:not(:nth-child(3)) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
    th:nth-child(1), td:nth-child(1) {
      width: 55%;
    }
    th:nth-child(3), td:nth-child(3) {
      width: 15%;
    }
    th:not(:nth-child(1)), td:not(:nth-child(1)) {
      text-align-last: right;
    }
  }

  /* #products-table-abc th:nth-child(2) {
  } */
  /* @media only screen and (min-width: 1200px) {
    #products-table-abc th:nth-child(3) {
      width: 150px;
    }
  } */

  .table-details-color {
    border: none !important;
    cursor: pointer;
  }

  #table-1 tbody tr:hover {
    color: #0BA7DA !important;
    background-color: rgba(11,167,218,.075) !important;
  }

  #table-2 tbody tr:hover {
    color: #FCBC2C !important;
    background-color: rgba(252,188,44,.075) !important;
  }
</style>
